// in src/MyNotification.js
import { Notification } from 'react-admin';

const DashboardNotification = props => <Notification {...props} autoHideDuration={0} />;

export default DashboardNotification;